import KeenSlider from "keen-slider";

function autoSwitch(slider) {
  let timeout;
  let mouseOver = false;

  function clearNextTimeout() {
    clearTimeout(timeout);
  }

  function nextTimeout() {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      if (mouseOver) {
        return;
      }
      slider.next();
    }, 2000);
  }

  slider.on("created", () => {
    slider.container.addEventListener("mouseover", () => {
      mouseOver = true;
      clearNextTimeout();
    });
    slider.container.addEventListener("mouseout", () => {
      mouseOver = false;
      nextTimeout();
    });

    nextTimeout();
  });
  slider.on("dragStarted", clearNextTimeout);
  slider.on("animationEnded", nextTimeout);
  slider.on("updated", nextTimeout);
}

function arrowNavigation(slider) {
  let wrapper, arrowLeft, arrowRight;

  function markup(remove) {
    wrapperMarkup(remove);
    arrowMarkup(remove);
  }

  function removeElement(elment) {
    elment.parentNode.removeChild(elment);
  }
  function createDiv(className) {
    const div = document.createElement("div");
    const classNames = className.split(" ");
    classNames.forEach((name) => div.classList.add(name));
    return div;
  }

  function arrowMarkup(remove) {
    if (remove) {
      removeElement(arrowLeft);
      removeElement(arrowRight);
      return;
    }
    arrowLeft = createDiv("c-arrow c-arrow--left");
    arrowLeft.addEventListener("click", () => slider.prev());
    arrowRight = createDiv("c-arrow c-arrow--right");
    arrowRight.addEventListener("click", () => slider.next());

    wrapper.appendChild(arrowLeft);
    wrapper.appendChild(arrowRight);
  }

  function wrapperMarkup(remove) {
    if (remove) {
      const parent = wrapper.parentNode;
      while (wrapper.firstChild) {
        {
          parent.insertBefore(wrapper.firstChild, wrapper);
        }
      }
      removeElement(wrapper);
      return;
    }
    wrapper = createDiv("navigation-wrapper");
    wrapper.style.position = "relative";
    slider.container.parentNode.appendChild(wrapper);
    wrapper.appendChild(slider.container);
  }

  slider.on("created", () => {
    markup();
  });
  slider.on("optionsChanged", () => {
    markup(true);
    markup();
  });
  slider.on("destroyed", () => {
    markup(true);
  });
}

const voiceSlider = document.getElementById("js-voice-slider");

if (voiceSlider) {
  new KeenSlider(
    voiceSlider,
    {
      breakpoints: {
        "(min-width: 768px)": {
          slides: {
            perView: 2.58,
            spacing: 20,
          },
        },
      },
      loop: true,
      slides: {
        origin: "center",
        perView: 1,
      },
    },
    [autoSwitch, arrowNavigation],
  );
}
